/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `pending_clearance` - Pending Clearance
 * * `cleared` - Cleared
 * * `not_cleared` - Not Cleared
 */
export enum ClearanceStatusEnum {
    PENDING_CLEARANCE = 'pending_clearance',
    CLEARED = 'cleared',
    NOT_CLEARED = 'not_cleared',
}
